import { isServer } from './ssr';

var _window;

try {
  _window = window;
} catch (e) {}

export function getWindow(rootElement) {
  var _a, _b;

  if (isServer() || typeof _window === 'undefined') {
    return undefined;
  }

  return (_b = (_a = rootElement === null || rootElement === void 0 ? void 0 : rootElement.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) !== null && _b !== void 0 ? _b : _window;
}